import React from "react";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const SocialButton = ({ url, classes, iconSrc, altText }) => {
  if (!url) return null;

  return (
    <a
      href={url}
      className={`social-button br-50 ${classes}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        src={iconSrc}
        alt={altText || "Social media icon"}
        className="light-gray color-transition dib social-icon"
      />
    </a>
  );
};

export default SocialButton;
